/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { api2 } from '@/libs/api';
import {
  Module,
} from 'vuex';
import { RootState } from './types';

export interface ReconData {
  bank: string;
  alias: string;
  file: string;
  payload: ReconPayload[];
}

export interface ReconPayload {
  TransDate?: string;
  BankDate?: string;
  TransNo?: string;
  BCARefID?: string;
  VANumber?: string;
  CustName?: string;
  TopupAmountBayarind?: number;
  TopupAmountBank?: number;
  Status?: string;
}

export interface BankPayload {
  name: string;
  alias: string;
}

export interface TopupPayload {
  comp_code: string;
  id_: string;
  status: string;
  store_name: string;
  total_amount: number;
  transaction_date: string;
  transaction_no: string;
  user_name: string;
  user_phone: string;
}

export type State = {
  data: ReconData[];
  bank: BankPayload[];
}

const states: State = {
  data: [],
  bank: [],
};

const reconModule: Module<State, RootState> = {
  state: states,
  mutations: {
    ADD_RECON_DATA(state, payload: ReconData) {
      const index = state.data.findIndex((v) => v.alias === payload.alias);
      if (index !== -1) {
        state.data[index] = payload;
        return;
      }
      state.data.push(payload);
    },
    UPDATE_RECON_DATA(state, payload: { idx: number; idxP: number; data: ReconPayload }) {
      if (typeof payload.idx === 'number' && typeof payload.idxP === 'number') {
        state.data[payload.idx].payload[payload.idxP] = {
          ...state.data[payload.idx].payload[payload.idxP],
          ...payload.data,
        };
      }
    },
    REMOVE_ALL_RECON_DATA(state, payload: boolean) {
      if (payload) {
        state.data = [];
      }
    },
    ADD_ALL_BANK_DATA(state, payload: BankPayload[]) {
      state.bank = payload;
    },
    ADD_UPDATE_PAYLOAD_BANK_DATA(state, payload: BankPayload) {
      const index = state.bank.findIndex((v) => v.alias === payload.alias);
      if (index !== -1) {
        state.bank[index] = payload;
        return;
      }
      state.bank.push(payload);
    },
    REMOVE_ALL_BANK_DATA(state, payload: boolean) {
      if (payload) {
        state.bank = [];
      }
    },
  },
  actions: {
    // async GET_BANK_DATA({ commit }) {
    //   const { data } = await api2.get<any[]>('/bank-topup');
    //   commit('ADD_ALL_BANK_DATA', data.map((v) => ({
    //     name: v?.bank_name || '',
    //     alias: v?.bayarind_bank_alias || '',
    //   })));
    // },
  },
};

export default reconModule;
